
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"0d548ae37d7219498d88c02d95257491df1fa49f":"generateLeadEmailURL","17ab89cde8d15eda091a5465a40bcc0ab43abf25":"generateConsumerAffiliateFormURL","1dd7fb535f9be59708125494e8da6eb37f4ff184":"getCookiePhoneNumber","8a676029b82d4b4da9b27e0d03c80ae4b1019544":"getCookieSourceKey","a7b3d44c54be06aef73b172a755c6edcc1fbaeeb":"affiliateCookies","f86f1318ce70e00b3f22d2019fdad171ed0826e1":"generateLeadFormURL"} */ export var generateConsumerAffiliateFormURL = createServerReference("17ab89cde8d15eda091a5465a40bcc0ab43abf25");
import { createServerReference } from "private-next-rsc-action-client-wrapper";
export var affiliateCookies = createServerReference("a7b3d44c54be06aef73b172a755c6edcc1fbaeeb");
export var getCookieSourceKey = createServerReference("8a676029b82d4b4da9b27e0d03c80ae4b1019544");
export var getCookiePhoneNumber = createServerReference("1dd7fb535f9be59708125494e8da6eb37f4ff184");
export var generateLeadFormURL = createServerReference("f86f1318ce70e00b3f22d2019fdad171ed0826e1");
export var generateLeadEmailURL = createServerReference("0d548ae37d7219498d88c02d95257491df1fa49f");

